import React from "react";
import PreloaderUI from "@components/preloader";
import { PreloaderStyles } from "./Preloader.styles";

const Preloader = () => (
  <PreloaderStyles>
    <PreloaderUI width={60} />
  </PreloaderStyles>
);

export default Preloader;
